export enum HomeAnalyticsMessages {
  capability = 'orders',
  pageName = 'us foods:r4:home',
  pageLoadedEvent = 'page loaded',
  alertsCapability = 'alerts',
  trackInteractBannerClickEvent = 'promo banner click',
  trackInteractBannersInViewport = 'feature engagement',
  trackInteractBannersEngagementType = 'marketing banner view',
}
